<template>
    <q-dialog v-model="modalKit" prevent-close>
        <span class="text-weight-bold" slot="title">
            <div class="row justify-end">
                <q-icon name="fa icon-close cursor-pointer" @click.native="close"
                        :disable="form.busy || isLoading"/>
            </div>
            <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'" style="font-weight:initial;">
                {{ $t('Confirm lending kit delivery?') + ' ' }}<b>{{ form.codentify }}?</b>
                <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
                <div v-if="form.busy" class="text-center q-mb-md">
                    <div class="text-body">Por favor, espere a que terminemos de procesar la orden</div>
                </div>
            </div>
        </span>

        <template slot="buttons" slot-scope="props">
            <div :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'" class="items-center">
                <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" no-caps text-color="primary" outline rounded :label="$t('cancel')" @click="close" :disable="form.busy || isLoading"  />
                <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" no-caps text-color="primary" outline rounded :label="$t('not received')" @click="moveTo('not-received')" :disable="form.busy || isLoading"  />
                <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" no-caps color="highlight" text-color="primary" rounded :label="$t('yes, received')" @click="moveTo('confirm-reception')" :disable="form.busy || isLoading"  />
            </div>
        </template>
    </q-dialog>
</template>

<script>
import Form from 'vform'
import {mapGetters} from 'vuex'
import lendingKitModel from './lendingKitModel'
import {
    QSpinnerPuff,
    QModal
} from 'quasar-framework'
import changeCase from 'change-case'
import axios from "axios";

export default {
    mixins: [lendingKitModel],

    components: {
        QSpinnerPuff,
        QModal
    },

    props: {
        show: Boolean,
        item: {
            type: Object,
            default: {}
        }
    },

    data() {
        return {
            stockStatuses: window.config.stockStatuses,
            modalKit: this.show,
            form: {},
            isLoading: false,
            action: 0,
            control: null,
            isMobile: false
        }
    },

    watch: {
        show(newVal) {
            this.modalKit = newVal
        },

        item(newVal) {
            this.form = new Form(Object.assign(this.lendingKitModel, newVal))
            let stockStatuses = this.stockStatuses
            this.action = this.form['stock_status.description'] === stockStatuses['BROKEN'] ? 22 : 0
        }
    },

    methods: {
        close() {
            this.modalKit = false
            this.action = 0
            this.$emit('close')
        },

        async getNotificationData() {
            const {data} = await axios.get(`${config.appUrl}/api/v1/notifications`)
            this.$store.commit('notifications/setToExpire', data.data.ordersToExpire)
            this.$store.commit('notifications/setExpiredNotClosed', data.data.ordersExpiredNotClosed)
            this.$store.commit('notifications/setKitsPendingReception', data.data.kitsPendingReception)
        },

        moveTo(stockStatus) {
            this.form.post(`${this.baseUrl}/lending-kit/${this.form.id}/move-to/${stockStatus}`, {
                status
            })
                .then(({data}) => {
                    if (data.hasOwnProperty('status') && !data.status) {
                        this.$q.dialog({
                            title: this.$T("error"),
                            message: data.message,
                            preventClose: true,
                            ok: {
                                label: this.$T('ok'),
                                outline: true,
                                rounded: true,
                                color: 'primary',
                                noCaps: true
                            },
                        })
                    } else {
                        this.close()
                        this.$emit('updated')
                        this.$q.dialog({
                            title: this.$T('success'),
                            message: data.success.message,
                            preventClose: true,
                            stackButtons: false,
                            ok: {
                                label: this.$T('ok'),
                                outline: true,
                                rounded: true,
                                color: 'primary',
                                noCaps: true
                            },
                        })
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            this.getNotificationData()
        },

        makeActionDataAdjustments() {

        }
    },

    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),

        baseUrl() {
            return `${window.config.appUrl}/api/v1/${changeCase.paramCase(this.user.role.name)}`
        },

        actions() {
            let role = this.user.role.name
            let stockStatus = this.form['stock_status.description']
            let stockStatuses = this.stockStatuses
            let forbiddenStatuses = [
                stockStatuses['IN_LENDING'],
                stockStatuses['RESERVED'],
                stockStatuses['RETIRED'],
                stockStatuses['NOT_RETURNED']
            ]

            let actions = [{value: 0, label: this.$T('no action')}]

            if ((role == 'Lending Point') && (stockStatus === stockStatuses['PENDING_RECEPTION'])) {
                actions = [
                    {value: 0, stockStatus: 'confirm-reception', label: `> ${this.$T('confirm reception')}`},
                    {value: 9, stockStatus: 'not-received', label: `> ${this.$T('not received')}`, color: 'red'}
                ]
            } else if (stockStatus === stockStatuses['CLEAR']) {
                actions = []
            } else {
                if ((role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' || role == 'Remote Coach') && stockStatus === stockStatuses['AVAILABLE']) {
                    actions = [
                        {value: 0, stockStatus: 'available', label: `> ${this.$T('available')}`},
                        {value: 22, stockStatus: 'broken', label: `> ${this.$T('broken')}`}
                    ]
                } else {
                    if ((!forbiddenStatuses.includes(stockStatus) && role == 'Courier') ||
                        (![stockStatuses['IN_LENDING'], stockStatuses['NOT_RECEIVED'], stockStatuses['BROKEN'], stockStatuses['SOLD']].includes(stockStatus) && (role == 'Lending Point' || role == 'Sales Expert' || role == 'MUPI' || role == 'Remote Coach'))) {
                        actions = [
                            {value: 0, stockStatus: 'available', label: `> ${this.$T('available')}`},
                            {value: 9, stockStatus: 'not-received', label: `> ${this.$T('not received')}`, color: 'red'}
                        ]
                    }
                }
            }

            return actions
        },

        loadForm() {
            return this.form && this.form.stock_status && this.form.stock_status.description
        }
    },

    mounted() {
        this.isMobile = this.$q.platform.is.mobile
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/_lendingKitPendingReceptionDetail.vue